import { AudiencePenetrationRow } from '../audience-penetration-types';

export interface AudiencePenetrationMetrics {
  audienceReachPct: number | null;
  audienceConversionPct: number | null;
  conversionRatePct: number | null;
}

// Naming Conventions / Calculated Fields from the reqs doc:
//   Audience Reach % = reach / total_users
//   Audience Conversion % = converted_users / total_users
//   Conversion Rate % = converted_users / reach
// `total_users` (segmentUserCount) is only populated for FSI clients, so these are null
// whenever it's missing rather than silently dividing by zero/undefined.
export const computeMetrics = (row: AudiencePenetrationRow): AudiencePenetrationMetrics => {
  const { reach, convertedUsers, segmentUserCount } = row;
  return {
    audienceReachPct: segmentUserCount ? reach / segmentUserCount : null,
    audienceConversionPct: segmentUserCount ? convertedUsers / segmentUserCount : null,
    conversionRatePct: reach > 0 ? convertedUsers / reach : null
  };
};

// Reqs doc: extend decimals to 3 places (%0.000).
export const formatPct = (value: number | null): string =>
  value === null ? '—' : `${(value * 100).toFixed(3)}%`;

export const formatCount = (value: number | null): string =>
  value === null ? '—' : value.toLocaleString('en-US');
